var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("h4", [_vm._v("Sent to TWC")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.ordersLoading,
                            disabled: _vm.ordersLoading,
                            fab: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.searchOrders()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-data-table",
                        {
                          attrs: {
                            id: "orderTable",
                            headers: _vm.headers,
                            "item-key": "id",
                            items: _vm.orders,
                            loading: _vm.ordersLoading,
                            pagination: _vm.pagination,
                            "total-items": _vm.totalOrders,
                            "rows-per-page-items": _vm.rowsPerPageItems,
                            expand: true
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.deliveryOrInstall(
                                          props.item.orderID
                                        )
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        props.expanded = !props.expanded
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      attrs: { width: "20%" },
                                      on: {
                                        click: function($event) {
                                          props.expanded = !props.expanded
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            flat: "",
                                            color: "primary",
                                            target: "_blank",
                                            to:
                                              "/order/" + props.item.orderID._id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(props.item.orderID.orderCode)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      on: {
                                        click: function($event) {
                                          props.expanded = !props.expanded
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            flat: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectOrder(
                                                props.item.orderID._id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              props.item.orderID.customerID
                                                .firstName
                                            ) +
                                              " " +
                                              _vm._s(
                                                props.item.orderID.customerID
                                                  .lastName
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", {
                                    attrs: { width: "25%" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getProducts(
                                          props.item.orderID.orderCode
                                        )
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        props.expanded = !props.expanded
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    attrs: { width: "15%" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getStatusHtml(props.item.twcStatus)
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        props.expanded = !props.expanded
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      on: {
                                        click: function($event) {
                                          props.expanded = !props.expanded
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          new Date(
                                            props.item.twcOrderDate
                                          ).getDate() +
                                            "/" +
                                            (new Date(
                                              props.item.twcOrderDate
                                            ).getMonth() +
                                              1) +
                                            "/" +
                                            new Date(
                                              props.item.twcOrderDate
                                            ).getFullYear()
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      on: {
                                        click: function($event) {
                                          props.expanded = !props.expanded
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          new Date(
                                            props.item.twcEstDueDate
                                          ).getDate() +
                                            "/" +
                                            (new Date(
                                              props.item.twcEstDueDate
                                            ).getMonth() +
                                              1) +
                                            "/" +
                                            new Date(
                                              props.item.twcEstDueDate
                                            ).getFullYear()
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "expand",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "60%",
                                        margin: "0 auto",
                                        "text-align": "center",
                                        background: "#eee"
                                      }
                                    },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          "Individual TWC Orders - " +
                                            _vm._s(props.item.orderID.orderCode)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        { attrs: { width: "100%" } },
                                        [
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", {
                                                  staticClass: "text-left"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Order Number")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Status")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Date")]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.getOrdersByOrderCode(
                                                  props.item.orderID.orderCode
                                                ),
                                                function(item, index) {
                                                  return _c(
                                                    "tr",
                                                    { key: index },
                                                    [
                                                      _c("td", {
                                                        attrs: { width: "10%" },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.productAssets[
                                                              item.type
                                                            ]
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            width: "30%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.twcOrderNumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("td", {
                                                        attrs: { width: "30%" },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.getStatusHtml(
                                                              item.twcStatus
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            width: "30%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              new Date(
                                                                item.twcEstDueDate
                                                              ).getDate() +
                                                                "/" +
                                                                (new Date(
                                                                  item.twcEstDueDate
                                                                ).getMonth() +
                                                                  1) +
                                                                "/" +
                                                                new Date(
                                                                  item.twcEstDueDate
                                                                ).getFullYear()
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              slot: "progress",
                              color: "primary",
                              indeterminate: ""
                            },
                            slot: "progress"
                          }),
                          _vm._v(" "),
                          _vm._v(" "),
                          _vm._v(" "),
                          _c("template", { slot: "no-data" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.loadingText) +
                                "\n            "
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md2: "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Search and Filter")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "v-text-field" }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableInstallorDelivery,
                          chips: "",
                          clearable: "",
                          label: "Filter Order Type",
                          multiple: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.enabledInstallorDelivery,
                          callback: function($$v) {
                            _vm.enabledInstallorDelivery = $$v
                          },
                          expression: "enabledInstallorDelivery"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.customerDialog,
            callback: function($$v) {
              _vm.customerDialog = $$v
            },
            expression: "customerDialog"
          }
        },
        [
          _vm.selectedOrder
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(_vm.selectedOrder.orderID.orderCode) +
                        " - Customer Details"
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v(
                        "Name: " +
                          _vm._s(
                            _vm.selectedOrder.orderID.customerID.firstName
                          ) +
                          " " +
                          _vm._s(_vm.selectedOrder.orderID.customerID.lastName)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Phone: " +
                          _vm._s(_vm.selectedOrder.orderID.customerID.phone)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Email: " +
                          _vm._s(_vm.selectedOrder.orderID.customerID.email)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Address: " + _vm._s(_vm.selectedCustomerAddress))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.customerDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            flat: "",
                            target: "_self",
                            to:
                              "/customers/" +
                              _vm.selectedOrder.orderID.customerID._id
                          }
                        },
                        [_vm._v("Go to Customer")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670d716a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670d716a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/senttotwc/SentToTWC.vue
// module id = null
// module chunks = 